(function ($) {

    /*------------------------------------*\
        ANY

        Returns true if a jQuery collection is non-empty.

        EXAMPLE

        var items = $(".item");
        if (items.any()) { ... }

    \*------------------------------------*/
    $.fn.any = function () {
        return this.length > 0;
    };


    /*------------------------------------*\
        PARSE SETTINGS

        Parses a data-settings JSON attribute into a plain object.

        EXAMPLE

        <div data-settings='{"setting1": true}'></div>

        var settings = $(".item").parseSettings();
        settings.setting1; // true

    \*------------------------------------*/
    $.fn.parseSettings = function () {

        var elem     = $(this),
            response = {};

        if (elem.attr('data-settings')) {

            try {
                response = JSON.parse(elem.attr('data-settings'));
            } catch (ex) {
                console.error('parseSettings: invalid JSON —', ex.message);
                return {};
            }

        }

        return response;

    };


    /*------------------------------------*\
        URL PARAMS

        Parses the current query string into a key/value object.

        EXAMPLE

        var params = $.getUrlParams();
        params.page; // "2"

    \*------------------------------------*/
    $.extend({

        getUrlParams: function () {

            var response    = {},
                data        = window.location.href.toLowerCase(),
                queryParams = data.split('?')[1];

            if (!queryParams) { return response; }

            var pairs = queryParams.split('&');

            for (var i = 0, l = pairs.length; i < l; i++) {
                var pair = pairs[i].split('=');
                response[pair[0]] = pair[1];
            }

            return response;

        }

    });


    /*------------------------------------*\
        ESC

        Binds a callback to the Escape key.

        EXAMPLE

        $.esc({
            callback: function (evt) {
                // close modal etc.
            }
        });

    \*------------------------------------*/
    $.extend({

        esc: function (options) {

            var settings = $.extend(true, { callback: null }, options);

            if (typeof settings.callback === 'function') {

                $(document).on('keyup.esc', function (evt) {

                    if (evt.key === 'Escape' || evt.keyCode === 27) {
                        settings.callback(evt);
                    }

                });

            }

        }

    });

}(jQuery));


/*------------------------------------*\
    DEBOUNCE

    Returns a debounced version of a function that only fires
    after N ms of inactivity.

    Via David Walsh — https://davidwalsh.name/javascript-debounce-function

\*------------------------------------*/
function debounce(func, wait, immediate) {

    var timeout;

    return function () {

        var context = this,
            args    = arguments;

        var later = function () {
            timeout = null;
            if (!immediate) { func.apply(context, args); }
        };

        var callNow = immediate && !timeout;

        clearTimeout(timeout);
        timeout = setTimeout(later, wait);

        if (callNow) { func.apply(context, args); }

    };

}
